function buttonfeature() {
  const e = $('.featureLineupContainer');
  if (e.length > 0) {
    e.each((index, element) => {
      const moreButton = $(element).find('.featureLineup-more');

      const textContainer = $(element).find('.featureLineup-text');
      const titleElem = $(element).find('.featureLineup-title');
      const descriptionText = $(element).find('.featureLineup-text').text().trim();

      const titleText = titleElem.text().trim(); // Get the title text and trim any extra whitespace
      const maxLengthTitle = 20; // Maximum characters for title
      const maxLengthDescription = 60; // Maximum characters for description

      // Limit title length
      let trimmedTitle =
        titleText.length > maxLengthTitle
          ? titleText.substring(0, maxLengthTitle) + '...'
          : titleText;

      // Limit description length
      let trimmedDescription =
        descriptionText.length > maxLengthDescription
          ? descriptionText.substring(0, maxLengthDescription) + '...'
          : descriptionText;

      // Create a wrapper div for buttons
      const buttonWrap = $('<div class="button-wrap"></div>');

      // Append both buttons to the wrapper div
      buttonWrap.append(moreButton);

      if (textContainer.length > 0) {
        // If .featureLineup-text exists
        textContainer.html(`<span class="featureLineup-text-content">${trimmedDescription}</span>`); // Use trimmed description
        buttonWrap.appendTo(textContainer); // Append buttonWrap to .featureLineup-text
        titleElem.text(trimmedTitle); // Set trimmed title
        titleElem.clone().appendTo(textContainer); // Append cloned title
      } else {
        // If .featureLineup-text does not exist
        titleElem.text(trimmedTitle); // Set trimmed title
        buttonWrap.prepend(titleElem.clone()); // Prepend cloned title to buttonWrap
        buttonWrap.append(`<span class="featureLineup-text-content">${trimmedDescription}</span>`); // Append trimmed description
        $(element).append(buttonWrap); // Append buttonWrap to the container
      }
    });
  }
}

$(document).ready(function () {
  const dropdownContainer = $('.mobile-menu-container');

  // Dropdown script for ticket button and containers
  $('.mobile-menu-footer-links').empty();
  $(dropdownContainer).append('<div class="dropdown-wrap"></div>');
  $(dropdownContainer).find('.mobile-menu-slider').appendTo('.dropdown-wrap');
  $(dropdownContainer).find('.mobile-menu-header').append('<div class="inner-container"></div>');
  $('.header-logo').clone().appendTo('.mobile-menu-container .inner-container');
  $('.header a.ticket').clone().appendTo('.mobile-menu-container .inner-container');
  $(dropdownContainer)
    .find('.close-mobile-menu')
    .appendTo('.mobile-menu-container .inner-container');
  $('<div class="top-header-mobile"></div>').prependTo('.mobile-menu-container');
  $('.login-status-link').clone().appendTo('.mobile-menu-container .top-header-mobile');
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  buttonfeature();
});

$(window).load(function () {
  $('.emailSignup .emailSubmitButton').text('Subscribe');
  // ---
});
